export const OTP_HISTORY_URL = '/otp-history'
